import React, { useEffect, useState } from "react";
import Avatar from "../../components/Avatar";
import Footer from "../../components/Footer";
import Typewriter from "typewriter-effect";
import DownloadCv from "../../components/DownloadCv";
import { client, getAuthor } from "../../client";
import { HomeContainer, HomeStyled, Left, PageLayout, Right } from "./styles";
import About from "../About/About";
import Skills from "../Skills/Skills";
import Projects from "./../Projects/Projects";
import Contact from "../Contact/Contact";
import imageUrlBuilder from "@sanity/image-url";
import Socials from "./Socials";
// import { getFileAsset } from "@sanity/asset-utils/dist";

const builder = imageUrlBuilder(client);

// function getSanityFileUrl(sanityFile) {
//   const fileUrl = getFileAsset(sanityFile.asset, {
//     projectId: "lgxifnkz",
//     dataset: "production",
//   });
//   console.log(fileUrl);
// }

function urlFor(source) {
  return builder.image(source);
}

function Home({ mobileFalse }) {
  const [author, setAuthor] = useState([]);

  const callGetAuthor = async () => {
    const posts = await getAuthor();
    setAuthor(posts[0]);
  };

  useEffect(() => {
    callGetAuthor();
  }, []);

  return (
    <HomeStyled onClick={mobileFalse}>
      <HomeContainer id="home">
        {author?.name && (
          <>
            <Left>
              <Typewriter
                onInit={(typewriter) => {
                  typewriter
                    .typeString(`<h2>${author?.name}</h2><h4>${author?.stack}`)
                    .start();
                }}
              />
              <DownloadCv
                text={"download cv"}
                link="/util/Ekwealor_Hillary_Résumé._v2.pdf.pdf"
              />
            </Left>
            <Right>
              <Avatar imageUrl={urlFor(author?.image)} />
            </Right>
          </>
        )}
      </HomeContainer>
      {author?.bio && (
        <PageLayout id="about">
          <About about={author?.bio[0]?.children[0]?.text} />
        </PageLayout>
      )}
      <PageLayout id="skills">
        <Skills />
      </PageLayout>
      <PageLayout id="projects">
        <Projects />
      </PageLayout>
      <PageLayout id="contact">
        <Contact />
      </PageLayout>
      <Socials />
      <Footer />
    </HomeStyled>
  );
}

export default Home;
